import { db } from '../../data/base';
import { collection, getDocs, query, where } from 'firebase/firestore';

import leoProfanity from 'leo-profanity';

/**
 * Checks if a catalogue name is already in use
 * @param {string} name - The catalogue name to check
 * @returns {Promise<boolean>} - True if the name is available, false otherwise
 */
export const isCatalogueNameAvailable = async (name) => {
  if (!name) return false;

  try {
    const cataloguesRef = collection(db, 'Catalogues');
    const q = query(cataloguesRef, where('nameCatalog', '==', name));
    const querySnapshot = await getDocs(q);

    return querySnapshot.empty; // If empty, name is available
  } catch (error) {
    console.error('Error checking catalogue name availability:', error);
    throw new Error('Failed to check catalogue name availability');
  }
};

/**
 * Controlla se il dominio è "pulito" (senza parole offensive) usando leo-profanity
 * @param {string} domain - Il dominio da controllare
 * @returns {boolean} - true se il dominio è pulito, false se contiene parole offensive
 */
export const isDomainClean = (domain) => {
  if (!domain) return false;
  // Normalizza il dominio (solo lettere e numeri, minuscolo)
  const normalized = domain.toLowerCase().replace(/[^a-z0-9]/g, '');
  return !leoProfanity.check(normalized);
};

/**
 * Validates a domain name format
 * @param {string} domain - The domain to validate
 * @returns {boolean} - True if the domain format is valid
 */
export const isValidDomainFormat = (domain) => {
  if (!domain) return false;

  // Domain can only contain lowercase letters, numbers, and hyphens
  // It cannot start or end with a hyphen
  // It must be between 3 and 63 characters long
  const domainRegex = /^[a-z0-9]([a-z0-9-]{1,61}[a-z0-9])?$/;
  return domainRegex.test(domain);
};


/**
 * Controlla se un dominio è già in uso sulla chiave 'webDomain' nella collezione 'Catalogues'.
 * @param {string} domain - Il dominio da controllare (senza .webvto.it)
 * @returns {Promise<boolean>} - True se il dominio è disponibile, false altrimenti
 */
export const isDomainAvailable = async (domain) => {
  if (!domain) return false;
  try {
    const cataloguesRef = collection(db, 'Catalogues');
    const webDomainValue = `${domain}.webvto.it`;
    const q = query(cataloguesRef, where('webDomain', '==', webDomainValue));
    const querySnapshot = await getDocs(q);
    return querySnapshot.empty; // Se è vuoto, il dominio è disponibile
  } catch (error) {
    console.error('Error checking domain availability:', error);
    throw new Error('Failed to check domain availability');
  }
};

/**
 * Formats a domain to the full URL format
 * @param {string} domain - The domain to format
 * @returns {string} - The formatted URL
 */
export const formatDomainUrl = (domain) => {
  if (!domain) return '';
  return `https://${domain}.webvto.it/`;
};
